import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const resetData = (state) => {
  state.productRecommendationList = [];
};

const productRecommendationListSuccess = (state, productRecommendationList) => {
  state.productRecommendationList = productRecommendationList;
};

const createProductRecommendationListSuccess = (state, productRecommendation) => {
  state.productRecommendationList.push(productRecommendation);
};

const editProductRecommendationListSuccess = (state, productRecommendation) => {
  const index = state.productRecommendationList.findIndex((recommendation) => recommendation.guid === productRecommendation.guid);
  state.productRecommendationList.splice(index, 1, productRecommendation);
};

const removeProductRecommendationListSuccess = (state, productRecommendationGuid) => {
  state.productRecommendationList = state.productRecommendationList.filter((pr) => pr.guid !== productRecommendationGuid);
};

export const mutations = {
  [MutationTypes.PRODUCT_RECOMMENDATION_LIST_SUCCESS]: productRecommendationListSuccess,
  [MutationTypes.CREATE_PRODUCT_RECOMMENDATION_SUCCESS]: createProductRecommendationListSuccess,
  [MutationTypes.EDIT_PRODUCT_RECOMMENDATION_SUCCESS]: editProductRecommendationListSuccess,
  [MutationTypes.REMOVE_PRODUCT_RECOMMENDATION_SUCCESS]: removeProductRecommendationListSuccess,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
